import React from "react";
import { Typography, Paper, Grid, Box } from "@mui/material";
import LinkIcon from "@material-ui/icons/Link";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { useNavigate } from "react-router-dom";

const quickLinkGradients = [
  "linear-gradient(135deg,  0%, 100%)",
  "linear-gradient(135deg,  0%, 100%)",
  "linear-gradient(135deg,  0%,  100%)",
  "linear-gradient(135deg,  0%,  100%)",
];

function QuickLinks({ quickLinkData }) {
  const navigate = useNavigate();

  return (
    <Box sx={{ mb: 4, mt: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
        <Box
          sx={{
            width: 4,
            height: 28,
            background: "linear-gradient(180deg, #667eea 0%, #764ba2 100%)",
            borderRadius: 2,
          }}
        />
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: "#1e293b",
            letterSpacing: "-0.5px",
          }}
        >
          Quick Links
        </Typography>
      </Box>

      <Grid container spacing={2.5}>
        {quickLinkData.map((data, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Paper
              elevation={0}
              onClick={() => navigate(data.link)}
              sx={{
                p: 2.5,
                borderRadius: 5,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#fff",
                border: "1px solid rgba(0,0,0,0.04)",
                cursor: "pointer",
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                position: "relative",
                overflow: "hidden",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: quickLinkGradients[index % quickLinkGradients.length],
                  opacity: 0,
                  transition: "opacity 0.3s ease",
                },
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: "0 16px 40px rgba(102, 126, 234, 0.2)",
                  "&::before": {
                    opacity: 1,
                  },
                  "& .quick-link-content": {
                    color: "#000000",
                  },
                  "& .icon-box": {
                    background: "rgba(255,255,255,0.2)",
                    color: "#fff",
                  },
                  "& .arrow-icon": {
                    opacity: 1,
                    transform: "translateX(0)",
                  },
                },
              }}
            >
              <Box
                className="quick-link-content"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                  zIndex: 1,
                  transition: "color 0.3s ease",
                }}
              >
                <Box
                  className="icon-box"
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 3,
                    background: quickLinkGradients[index % quickLinkGradients.length],
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 2,
                    color: "#fff",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                >
                  {data.icon ? data.icon : <LinkIcon fontSize="small" />}
                </Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    color: "#1e293b",
                    fontSize: "0.95rem",
                    transition: "color 0.3s ease",
                  }}
                  className="quick-link-content"
                >
                  {data.label}
                </Typography>
              </Box>
              {/* <ArrowForwardIcon
                className="arrow-icon"
                sx={{
                  position: "relative",
                  zIndex: 1,
                  color: "#fff",
                  opacity: 0,
                  transform: "translateX(-10px)",
                  transition: "all 0.3s ease",
                  fontSize: "1.2rem",
                }}
              /> */}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default QuickLinks;